export const MIN_SANDBOX_VOLUME_SIZE_IN_GB = 10;
export const MAX_SANDBOX_VOLUME_SIZE_IN_GB = 16384;

export const MIN_SANDBOX_IDLE_TIME_SETTING_IN_MIN = 1;
export const MAX_SANDBOX_IDLE_TIME_SETTING_IN_MIN = 4320;

export const MIN_SANDBOX_IDLE_CPU_UTIL_PERCENTAGE = 1;
export const MAX_SANDBOX_IDLE_CPU_UTIL_PERCENTAGE = 100;

export enum SANDBOX_STATUS {
    FAILED,
    IN_SERVICE,
    STOPPED,
    UPDATING,
    CREATING,
    STARTING,
    STOPPING
}

export function stringToSandboxStatus(status: string): SANDBOX_STATUS {
    const lowerCaseStatus = status.toLowerCase();
    if (lowerCaseStatus === "failed") {
        return SANDBOX_STATUS.FAILED;
    } else if (lowerCaseStatus === "inservice") {
        return SANDBOX_STATUS.IN_SERVICE;
    } else if (lowerCaseStatus === "stopped") {
        return SANDBOX_STATUS.STOPPED;
    } else if (lowerCaseStatus === "updating") {
        return SANDBOX_STATUS.UPDATING;
    } else if (lowerCaseStatus === "creating") {
        return SANDBOX_STATUS.CREATING;
    } else if (lowerCaseStatus === "starting") {
        return SANDBOX_STATUS.STARTING;
    } else if (lowerCaseStatus === "stopping") {
        return SANDBOX_STATUS.STOPPING;
    } else {
        throw new Error(`Unrecognized sandbox status "${status}"`);
    }
}
